import React, { useState, useEffect } from 'react';
import { creditsAPI } from '../services/api';

const Credits = () => {
  const [credits, setCredits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCredits();
  }, []);

  const fetchCredits = async () => {
    try {
      setLoading(true);
      const response = await creditsAPI.getAll();
      setCredits(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching credits:', err);
      setError('Failed to load credits. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-red-600 mx-auto mb-4"></div>
          <p className="text-xl">Loading credits...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <p className="text-xl text-red-300 mb-4">{error}</p>
          <button 
            onClick={fetchCredits}
            className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-red-500 to-red-700 bg-clip-text text-transparent">
            Credits
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Meet the amazing people who make ISMP server possible
          </p>
        </div>

        {credits.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-xl text-gray-400">No credits found.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {credits.map((credit) => (
              <div
                key={credit.id}
                className="bg-gray-800/50 backdrop-blur-sm border border-red-600/30 rounded-lg p-6 hover:border-red-500/50 transition-all duration-200 hover:shadow-lg hover:shadow-red-600/20"
              >
                <div className="text-center">
                  {credit.photo && (
                    <div className="mb-4">
                      <img 
                        src={credit.photo} 
                        alt={credit.name} 
                        className="w-20 h-20 rounded-full object-cover mx-auto border-2 border-red-600/50"
                      />
                    </div>
                  )}
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {credit.name}
                  </h3>
                  <div className="inline-block bg-red-600/80 px-3 py-1 rounded-full text-sm font-semibold text-white mb-3">
                    {credit.role}
                  </div>
                  {credit.description && (
                    <p className="text-gray-300 text-sm leading-relaxed">
                      {credit.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-12">
          <div className="bg-gray-800/50 backdrop-blur-sm border border-red-600/30 rounded-lg p-6 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-3">Want to Help?</h3>
            <p className="text-gray-300 mb-4">
              ISMP is always looking for dedicated members to join our team. Whether you're interested in 
              moderation, building, event planning, or technical support, there's a place for you.
            </p>
            <p className="text-gray-400 text-sm">
              Contact the admin team to learn about opportunities to contribute to our community!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Credits;